// tslint:disable
export enum AccountLocationPurposeType {
    // UNKN
    UNKN = 0,
    // HDQTR
    HDQTR = 1,
    // SALE
    SALE = 2,
    // HOME
    HOME = 3,
    // WORK
    WORK = 4,
    // SEAS
    SEAS = 5,
    // MAIL
    MAIL = 6,
    // BILL
    BILL = 7,
    // SHIP
    SHIP = 8,
}
